<div class="search-wrapper" [class.focused]="focused()" [class.has-value]="value()">
  <ptl-icon class="search-icon" [icon]="LucideSearch" size="xs" />
  <input
    type="text"
    class="search-input"
    [value]="value()"
    [placeholder]="placeholder() ?? ('translations.global.label.searchPlaceholder' | transloco)"
    (input)="onInput($event)"
    (focus)="focused.set(true)"
    (blur)="focused.set(false)"
  />
</div>
